import axios from "axios";
import config from "../config";
import {stringify} from "query-string";
import {Toast} from "vant";

const ax = axios.create({
  baseURL: config.api_url,
  headers: {"Content-Type": "application/x-www-form-urlencoded"}
});
export default {
  getClassName(obj) {
    if (obj && obj.constructor && obj.constructor.toString()) {
      if (obj.constructor.name) {
        return obj.constructor.name;
      }
      let str = obj.constructor.toString();
      let arr;
      if (str.charAt(0) == '[') {
        arr = str.match(/\w+\s∗(\w+)\w+\s∗(\w+)/);
      } else {
        arr = str.match(/function\s*(\w+)/);
      }
      if (arr && arr.length == 2) {
        return arr[1];
      }
    }
    return undefined;
  },
  request(api, host) {
    let path = api.path;
    if (typeof api.params['QApi\\Attribute\\Parameter\\PathParam'] != "undefined") {
      for (let i = 0; i < api.params['QApi\\Attribute\\Parameter\\PathParam'].length; i++) {
        path = path.replace('{' + api.params['QApi\\Attribute\\Parameter\\PathParam'][i]['name'] + '}', api.params['QApi\\Attribute\\Parameter\\PathParam'][i]['default']);
      }
    }
    if (typeof api.params['QApi\\Attribute\\Parameter\\PathParamFromTableField'] != "undefined") {
      for (let i = 0; i < api.params['QApi\\Attribute\\Parameter\\PathParamFromTableField'].length; i++) {
        path = path.replace('{' + api.params['QApi\\Attribute\\Parameter\\PathParamFromTableField'][i]['name'] + '}', api.params['QApi\\Attribute\\Parameter\\PathParamFromTableField'][i]['default']);
      }
    }
    let headers = {
      '_QApi': 'QApiDocument',
    };
    if (typeof api.params['QApi\\Attribute\\Parameter\\HeaderParam'] != "undefined") {
      for (let i = 0; i < api.params['QApi\\Attribute\\Parameter\\HeaderParam'].length; i++) {
        headers[api.params['QApi\\Attribute\\Parameter\\HeaderParam'][i]['name']] = api.params['QApi\\Attribute\\Parameter\\HeaderParam'][i]['default'] || '';
      }
    }
    let getData = {};
    if (typeof api.params['QApi\\Attribute\\Parameter\\GetParam'] != "undefined") {
      for (let i = 0; i < api.params['QApi\\Attribute\\Parameter\\GetParam'].length; i++) {
        getData[api.params['QApi\\Attribute\\Parameter\\GetParam'][i]['name']] = api.params['QApi\\Attribute\\Parameter\\GetParam'][i]['default'] || '';
      }
    }
    if (typeof api.params['QApi\\Attribute\\Parameter\\GetParamFromTableField'] != "undefined") {
      for (let i = 0; i < api.params['QApi\\Attribute\\Parameter\\GetParamFromTableField'].length; i++) {
        getData[api.params['QApi\\Attribute\\Parameter\\GetParamFromTableField'][i]['name']] = api.params['QApi\\Attribute\\Parameter\\GetParamFromTableField'][i]['default'] || '';
      }
    }
    let postData = {};
    if (typeof api.params['QApi\\Attribute\\Parameter\\PostParam'] != "undefined") {
      for (let i = 0; i < api.params['QApi\\Attribute\\Parameter\\PostParam'].length; i++) {
        postData[api.params['QApi\\Attribute\\Parameter\\PostParam'][i]['name']] = api.params['QApi\\Attribute\\Parameter\\PostParam'][i]['default'] || '';
      }
    }
    if (typeof api.params['QApi\\Attribute\\Parameter\\PostParamFromTableField'] != "undefined") {
      for (let i = 0; i < api.params['QApi\\Attribute\\Parameter\\PostParamFromTableField'].length; i++) {
        postData[api.params['QApi\\Attribute\\Parameter\\PostParamFromTableField'][i]['name']] = api.params['QApi\\Attribute\\Parameter\\PostParamFromTableField'][i]['default'] || '';
      }
    }
    for (let k in postData) {
      if (typeof postData[k] == 'object') {
        if (this.getClassName(postData[k]) === 'File') {
          headers['Content-Type'] = 'multipart/form-data';
        }
      }
    }
    if (headers['Content-Type'] === 'multipart/form-data') {
      let forms = new FormData();
      for (let kk in postData) {
        forms.append(kk, postData[kk]);
      }
      postData = forms;
    }
    return ax.request({
      url: host + path,
      method: api.type === 'ALL' ? 'get' : api.type,
      headers: headers,
      params: getData,
      data: this.getClassName(postData) === 'FormData' ? postData : stringify(postData),
    });
  },
  getJSON(url, params) {
    if (!params) {
      params = {};
    }
    return new Promise((resolve, reject) => {
      ax.request({
        url: url,
        method: 'get',
        params: params,
      }).then(data => {
        if (data.data.code===403){
          localStorage.removeItem('password');
          location.reload();
        }else{
          resolve(data.data);
        }
      }).catch(res => {
        Toast('网络请求故障~');
        reject(res);
      });
    });
  },
  delete(url, params) {
    if (!params) {
      params = {};
    }
    return new Promise((resolve, reject) => {
      ax.request({
        url: url,
        method: 'delete',
        params: params,
      }).then(data => {
        if (data.data.code===403){
          localStorage.removeItem('password');
          location.reload();
        }else{
          resolve(data.data);
        }
      }).catch(res => {
        Toast('网络请求故障~');
        reject(res);
      });
    });
  },
  post(url, params, data) {
    if (!params) {
      params = {};
    }
    return new Promise((resolve, reject) => {
      ax.request({
        url: url,
        method: 'post',
        params: params,
        data: stringify(data),
      }).then(data => {
        if (data.data.code===403){
          localStorage.removeItem('password');
          location.reload();
        }else{
          resolve(data.data);
        }
      }).catch(res => {
        Toast('网络请求故障~');
        reject(res);
      });
    });
  },
}
